const formatBytes = (n: number) => {
  if (n < 1024) return `${n} B`;
  const i = Math.floor(Math.log(n) / Math.log(1024));
  const sizes = ['B', 'KB', 'MB', 'GB', 'TB'];

  return `${(n / Math.pow(1024, i)).toFixed(1)} ${sizes[i]}`;
};
export default formatBytes;
